import { useEffect, useState } from "react";

import addGroupRuns from "../helpers/addGroupRuns.mjs";
import addPeamans from "../helpers/addPeamans.mjs";
import compareEventDates from "../helpers/compareEventDates.mjs";
import EventCard from "../components/calendar/EventCard";
import getCalendarEvents from "../helpers/getCalendarEvents.mjs";
import { months } from "../helpers/monthsArray.mjs";
import processEvent from "../helpers/processEvent.mjs";

export default function Calendar() {
  const now = new Date();
  let eventCounter = 0;
  const [events, setEvents] = useState();
  const [month, setMonth] = useState(now.getMonth());
  const [year, setYear] = useState(now.getFullYear());
  const [eventsDisplayed, setEventsDisplayed] = useState(false);

  async function getAndSetCalendarData() {
    let groupRunData, peamanData;
    const cancelledGroupRuns = [];
    const cancelledPeamans = ["3/29/2026"];
    const data = await getCalendarEvents();
    // console.log(data);
    const processedEvents = [];
    data.forEach((event) => {
      if (
        event.id.includes("142s9ovecq167c5k6clim28a0l") &&
        event.status === "cancelled"
      ) {
        cancelledGroupRuns.push(event.originalStartTime.dateTime);
      }
      if (
        event.id.includes("61bvc6eo61osu1iv36bsemqktv") &&
        event.status === "cancelled"
      ) {
        cancelledPeamans.push(event.originalStartTime.dateTime);
      }
      if (event.id === "142s9ovecq167c5k6clim28a0l") {
        groupRunData = {
          name: event.summary,
          description: event.description,
          time: event.start.dateTime,
          location: event.location,
        };
      }
      if (event.id === "61bvc6eo61osu1iv36bsemqktv") {
        peamanData = {
          name: event.summary,
          description: event.description,
          time: event.start.dateTime,
          location: event.location,
        };
      }
      processEvent(event, processedEvents);
    });
    addGroupRuns(groupRunData, processedEvents, cancelledGroupRuns);
    addPeamans(peamanData, processedEvents, cancelledPeamans);
    processedEvents.sort(compareEventDates);
    setTimeout(() => setEvents(processedEvents), 500);
  }

  useEffect(() => {
    getAndSetCalendarData();
  }, []);

  function changeMonth(advance) {
    if (advance) {
      if (month === 11) {
        setMonth(0);
        setYear(year + 1);
      } else setMonth(month + 1);
    } else {
      if (month === 0) {
        setMonth(11);
        setYear(year - 1);
      } else setMonth(month - 1);
    }
  }

  return (
    <div id="Calendar">
      <div className="container-flex bg-primary rounded-4 m-2 p-3">
        <div className="row text-center align-items-center">
          <div className="col text-end">
            <button className="btn" onClick={() => changeMonth(false)}>
              <i className="bi bi-caret-left-fill text-info"></i>
            </button>
          </div>
          <div className="col bg-white rounded-4 p-2">
            <h2 className="text-primary">
              {months[month]} {year}
            </h2>
          </div>
          <div className="col text-start">
            <button className="btn" onClick={() => changeMonth(true)}>
              <i className="bi bi-caret-right-fill text-info"></i>
            </button>
          </div>
        </div>
      </div>
      {Array.isArray(events) &&
        events.map((event, i) => {
          if (event.year === year && event.month === month && event.name) {
            eventCounter++;
            if (eventsDisplayed === false) setEventsDisplayed(true);
            return (
              <EventCard
                key={`event-card-${i}`}
                event={event}
                counter={eventCounter}
              />
            );
          }
          return true;
        })}
      {}
    </div>
  );
}
